"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var types_1 = require("../types");
function default_1(Component) {
    return function (props) {
        return (React.createElement(types_1.FormContextConsumer, null, function (_a) {
            var form = _a.form;
            return (React.createElement(types_1.FieldContextConsumer, null, function (fieldContext) {
                return (React.createElement(Component, __assign({}, __assign({}, props, fieldContext, { form: form }))));
            }));
        }));
    };
}
exports.default = default_1;
//# sourceMappingURL=formContextHOC.js.map